import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_BASE_URL } from "../../../config";
import { toast } from "react-toastify";

const WorkOrders = ({ assetId, isWorkable }) => {
  const [workOrders, setWorkOrders] = useState([]);

  // FORM STATES
  const [title, setTitle] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [cost, setCost] = useState("");
  const [summary, setSummary] = useState("");
  const [documentFile, setDocumentFile] = useState(null);

  useEffect(() => {
    fetchWorkOrders();
  }, [assetId]);

  // ---------------------------
  // LOAD WORK ORDER LIST
  // ---------------------------
  const fetchWorkOrders = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/asset/${assetId}/work-orders`);
      setWorkOrders(res.data);
    } catch (err) {
      console.error("Work order load error:", err);
    }
  };

  // ---------------------------
  // SUBMIT WORK ORDER
  // ---------------------------
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!title || !startDate || !endDate || !cost || !summary) {
      toast.error("All fields are required!", { position: "bottom-right" });
      return;
    }
    if (!documentFile) {
      toast.error("Please upload a document!", { position: "bottom-right" });
      return;
    }

    const formData = new FormData();
    formData.append("asset_id", assetId);
    formData.append("work_title", title);
    formData.append("work_start_date", startDate);
    formData.append("work_end_date", endDate);
    formData.append("work_cost", cost);
    formData.append("work_summary", summary);
    formData.append("work_doc", documentFile);

    try {
      await axios.post(`${API_BASE_URL}/asset/work-order`, formData, {
        headers: { "Content-Type": "multipart/form-data" }
      });

      toast.success("Work Order Saved!", { position: "bottom-right" });

      // Reset form
      setTitle("");
      setStartDate("");
      setEndDate("");
      setCost("");
      setSummary("");
      setDocumentFile(null);

      fetchWorkOrders();
    } catch (err) {
      console.error("Submit error:", err);
      toast.error("Failed to submit!", { position: "bottom-right" });
    }
  };

  // ---------------------------
  // NOT WORKABLE CONDITION
  // ---------------------------
  if (isWorkable === 0) {
    return (
      <div className="alert alert-warning">
        Asset is not in workable condition.  
        Please update asset status first to enable work orders.
      </div>
    );
  }

  return (
    <div className="card p-1">
      <h5>Work Orders</h5>

      {/* ------------------ FORM ------------------ */}
      <form onSubmit={handleSubmit} className="mb-4">
        <div className="row mb-3">

          <div className="col-md-12">
            <label>Work Title</label>
            <input
              type="text"
              className="form-control"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              placeholder="Work Title"
            />
          </div>

          <div className="col-md-4 mt-3">
            <label>Start Date</label>
            <input
              type="date"
              className="form-control"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
            />
          </div>

          <div className="col-md-4 mt-3">
            <label>End Date</label>
            <input
              type="date"
              className="form-control"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
            />
          </div>

          <div className="col-md-4 mt-3">
            <label>Cost</label>
            <input
              type="number"
              className="form-control"
              value={cost}
              onChange={(e) => setCost(e.target.value)}
              placeholder="0.00"
            />
          </div>

          <div className="col-md-12 mt-3">
            <label>Work Summary</label>
            <textarea
              className="form-control"
              value={summary}
              onChange={(e) => setSummary(e.target.value)}
              placeholder="Enter work summary"
              rows={3}
            ></textarea>
          </div>

          <div className="col-md-12 mt-3">
            <label>Upload Document</label>
            <input
              type="file"
              className="form-control"
              onChange={(e) => setDocumentFile(e.target.files[0])}
            />
          </div>

        </div>

        <button className="btn btn-primary">Save</button>
      </form>

      {/* ------------------ LIST ------------------ */}
      <h6>Work Order History</h6>

      {workOrders.length === 0 ? (
        <p>No work orders found.</p>
      ) : (
        <table className="table table-bordered mt-2">
          <thead>
            <tr>
              <th>Asset Code</th>
              <th>Asset Name</th>
              <th>Order Title</th>
              <th>Cost</th>
              <th>Date</th>
              <th>Document</th>
            </tr>
          </thead>

          <tbody>
            {workOrders.map((wo) => (
              <tr key={wo.order_id}>
                <td>{wo.company_asset_code}</td>
                <td>{wo.name}</td>
                <td>{wo.order_title}</td>
                <td>{wo.work_cost}</td>
<td>{new Date(wo.created_on).toLocaleDateString("en-GB")}</td>
                <td>
                  {wo.work_doc ? (
                    <a
                      href={`${API_BASE_URL.replace("/api", "")}/uploads/work_order/${wo.work_doc}`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {wo.work_doc}
                    </a>
                  ) : (
                    "No File"
                  )}
                </td>
              </tr>
            ))}
          </tbody>

        </table>
      )}
    </div>
  );
};

export default WorkOrders;
